const user = {
  state: {
    userObj: null
  },
  actions: {
    setUser: function (context, {userObj}) {
      context.state.userObj = userObj
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js